import React from 'react';
import { Button } from '@attentive-platform/stem-ui';

const TABLE_COLUMNS = [
  { label: 'Version', key: 'version' },
  { label: 'Date', key: 'date' },
  { label: 'Author', key: 'author' },
  { label: 'Changes', key: 'changes', isCustom: true },
];

export default function SOPVersionHistory({ history, expandedHistory, toggleHistoryCollapse, renderChanges, renderNewState }) {
  return (
    <div className='sop-version-history version-history'>
      <h3 className='sop-version-heading'>Version History</h3>
      <div className='overflow-x-auto'>
        <table className='table table-bordered w-100 mt-2'>
          <thead>
            <tr className='bg-light'>
              {TABLE_COLUMNS.map(col => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {history.length === 0 && (
              <tr><td colSpan={TABLE_COLUMNS.length} className='text-center py-2'>No version history yet.</td></tr>
            )}
            {history.map((row, i) => (
              <tr key={row.version + row.date}>
                {TABLE_COLUMNS.map(col => {
                  if (col.isCustom && col.key === 'changes') {
                    return (
                      <td key={col.key} style={{ textAlign: 'left' }}>
                        <div style={{ textAlign: 'left' }}>
                          <Button
                            size='small'
                            variant='text'
                            onClick={() => toggleHistoryCollapse(i)}
                            className='sop-expand-btn'
                          >
                            {expandedHistory[i] ? 'Hide' : 'Expand'}
                          </Button>
                          {expandedHistory[i] && (
                            <div>
                              {renderChanges(row.changes)}
                              {row.new_state && (
                                <>
                                  <hr style={{ margin: '12px 0' }} />
                                  <b>New State:</b>
                                  {renderNewState(row.new_state)}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                    );
                  }
                  return <td key={col.key}>{row[col.key]}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 